module.exports = __webpack_public_path__ + "static/media/timesheet-choose-project.90d093f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/timesheet-choose-project.svg
// module id = 1692
// module chunks = 0